import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import {
  CorrespondenceRequestCategoryDto,
  CorrespondenceDepartmentFunctionDto,
} from '@cradua/data';

@Component({
  selector: 'mrsoftapps-request-category-view',
  templateUrl: './request-category-view.component.html',
  styleUrls: ['./request-category-view.component.css'],
})
export class RequestCategoryViewComponent implements OnInit {
  @Input() functions: CorrespondenceDepartmentFunctionDto[];
  @Input() requestCategories: CorrespondenceRequestCategoryDto[];
  requestCategoryForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<CorrespondenceRequestCategoryDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  selectedFunction: any;
  filteredDelete: Array<any> = [];
  loading = true;
  filteredRequestCategories: Array<CorrespondenceRequestCategoryDto> = [];
  status: boolean;
  selectedFunctionId: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.requestCategoryForm = this.fb.group({
      RequestCategories: this.fb.array([]),
    });
  }

  // method to display countries
  setRequestCategory() {
    const control = this.requestCategoryForm.controls
      .RequestCategories as FormArray;
    this.filteredRequestCategories.forEach((e) => {
      control.push(
        this.fb.group({
          CorrespondenceRequestCategoryName:
            e.CorrespondenceRequestCategoryName,
          AccountableFunctionId: e.AccountableFunctionId,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.requestCategoryForm.controls
      .RequestCategories as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter state
  selectRequestCategory(event: string) {
    this.filteredRequestCategories = this.requestCategories.filter(
      (s) => s.AccountableFunctionId === event
    );

    this.selectedFunctionId = event;
    const control = this.requestCategoryForm.controls
      .RequestCategories as FormArray;

    if (this.filteredRequestCategories.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setRequestCategory();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add Country
  addRequestCategory() {
    const control = this.requestCategoryForm.controls
      .RequestCategories as FormArray;
    control.insert(
      0,
      this.fb.group({
        CorrespondenceRequestCategoryName: ['', Validators.required],
        AccountableFunctionId: this.selectedFunctionId,
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteRequestCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.requestCategoryForm.controls
          .RequestCategories as FormArray;
        control.removeAt(index);

        if (value.id != null && value.id !== '') {
          this.filteredDelete.push(value.id);
        }

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'requestCategory';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('requestCategory');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
